module.exports = __webpack_public_path__ + "img/rocket.4ea7b37.webp";